import api from './api';

const adminService = {
  /**
   * List all organisations on the platform with user/project counts.
   * super_admin only (backend-enforced).
   */
  async getOrganisations(params = {}) {
    const response = await api.get('/admin/organisations', { params });
    return response.data;
  },
};

export default adminService;
